import { addIframe } from 'utils/dom'
import { AbstractObserver } from 'utils/abstract-classes/abstract-observer'
import { ATTR_NAME } from 'constants/attr-name'

const {
    widget: { iframe: attrName }
} = ATTR_NAME

export class Iframe extends AbstractObserver {
    public constructor(protected el: HTMLElement) {
        super(el)
        this.activateObserver()
    }

    /**
     * Load the data and show the widget (if data was returned)
     */
    public render(): void {
        const scriptSource = this.el.getAttribute(attrName.scriptUrl)

        if (!scriptSource) {
            return
        }

        const widgetTitle = this.el.getAttribute(attrName.title)
        const widgetWidth = this.el.getAttribute(attrName.width)
        const widgetHeight = this.el.getAttribute(attrName.height)
        const widgetScrolling = this.el.getAttribute(attrName.scrolling)
        const iframeAllowPolicy = this.el.getAttribute(attrName.allowPolicy)
        const widgetStyle = this.el.getAttribute(attrName.style)
        addIframe(scriptSource, this.el, {
            title: widgetTitle || '',
            width: widgetWidth || '100%', // TODO should be an integer of pixels
            scrolling: widgetScrolling || 'no',
            height: widgetHeight || '100%', // TODO should be an integer of pixels
            allow: iframeAllowPolicy || '',
            style: widgetStyle || ''
        })
    }
}
